import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "toolbar",
  id: "kt_toolbar"
}
const _hoisted_2 = { class: "d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap container" }
const _hoisted_3 = { class: "d-flex flex-column align-items-start justify-content-center flex-wrap me-1" }
const _hoisted_4 = { class: "text-dark fw-bolder my-1" }
const _hoisted_5 = {
  key: 0,
  class: "text-muted fs-7 fw-bold ms-1"
}
const _hoisted_6 = {
  key: 0,
  class: "breadcrumb breadcrumb-line bg-transparent text-muted fw-bold p-0 my-1 fs-7"
}
const _hoisted_7 = { class: "breadcrumb-item" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Home ")
const _hoisted_9 = { class: "breadcrumb-item" }
const _hoisted_10 = { class: "breadcrumb-item text-dark" }
const _hoisted_11 = { class: "d-flex align-items-center flex-nowrap text-nowrap overflow-auto py-1" }
const _hoisted_12 = { class: "menu-title" }
const _hoisted_13 = {
  key: 0,
  class: "badge badge-pro badge-light-danger fw-bold fs-9 px-2 py-1 ms-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return false
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, [
              _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
              (_ctx.desc)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.desc), 1))
                : _createCommentVNode("", true)
            ]),
            (!_ctx.asideEnabled)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
                  _createElementVNode("li", _hoisted_7, [
                    _createVNode(_component_router_link, {
                      to: '/',
                      class: "text-muted"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_9, _toDisplayString(_ctx.breadcrumbs.section), 1),
                  _createElementVNode("li", _hoisted_10, _toDisplayString(_ctx.breadcrumbs.title), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_11, [
            (_ctx.dataReceived && _ctx.displayLinks)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.getSectionArray.pages, (item, i) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                    (item.pro)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(["btn btn-active-accent fw-bolder", { 'ms-3': i !== 0 }])
                        }, [
                          _createElementVNode("span", _hoisted_12, [
                            _createTextVNode(_toDisplayString(item.heading) + " ", 1),
                            (item.pro)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Pro"))
                              : _createCommentVNode("", true)
                          ])
                        ], 2))
                      : _createCommentVNode("", true),
                    (!item.pro)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 1,
                          to: item.route,
                          class: _normalizeClass([{ 'ms-3': i !== 0, active: item.route === _ctx.getActiveLink }, "btn btn-active-accent fw-bolder"])
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.heading), 1)
                          ]),
                          _: 2
                        }, 1032, ["to", "class"]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}